const aboutUsSectionStyles = {
    containerWrapper: {
        backgroundColor: "#FFFFFF",
        px: { xs: "20px", sm: "40px", md: "60px", lg: "90px" },
    },
    container: {
        backgroundColor: "#FFFFFF",
    },
    title: {
        fontSize: { xs: "24px", sm: "32px", md: "40px" },
        fontWeight: "400",
        lineHeight: { xs: "24px", sm: "36px", md: "48px" },
        color: "#0F0F0F",
        fontFamily: "Belleza",
    },
    titleLine: {
        mt: { xs: "11.02px", sm: "24.03px" },
        mb: { xs: "15.42px", sm: "20.32px" },
        width: { xs: "67.18px" },
        height: { xs: "1px" },
        backgroundColor: "#0F0F0F",
    },
    subtitle: {
        fontFamily: "Lexend",
        color: "#0F0F0F",
        fontSize: { xs: "11px", sm: "18px", md: "21px" },
        fontWeight: { xs: "500", sm: "600", md: "600" },
        lineHeight: { xs: "24px", sm: "21.6px", md: "25px" },
    },
    description: {
        fontFamily: "Lexend",
        color: "#0F0F0F",
        fontSize: { xs: "12px", sm: "14px", md: "16px" },
        fontWeight: "300",
        lineHeight: { xs: "16px", sm: "21.6px", md: "25px" },
    },
    listDescription: {
        display: "inline",
        fontFamily: "Lexend",
        color: "#0F0F0F",
        fontSize: { xs: "12px", sm: "14px", md: "16px" },
        fontWeight: "300",
        lineHeight: { xs: "16px", sm: "21.6px", md: "25px" },
        ml: "4px",
    },
    descriptionTitle: {
        display: "inline",
        fontFamily: "Lexend",
        color: "#0F0F0F",
        fontSize: { xs: "12px", sm: "14px", md: "16px" },
        lineHeight: { xs: "16px", sm: "21.6px", md: "25px" },
        fontWeight: "500",
    },
    list: {
        pt: "0px",
        listStyleType: "disc",
        ml: '20px'
    },
    listItem: {
        display: "list-item",
        p: "0px",        
    },
    img: {
        width: { xs: "100%" },
        height: { xs: "100%" },
        maxWidth: { xs: "100%", sm: "220px", md: "430.58px" },
        maxHeight: { xs: "auto", sm: "auto", md: "502.09px" },
        objectFit: "contain",
        pl: "10px",
    },
    buttonWrapper: {
        display: "flex",
        justifyContent: { xs: "center", sm: "flex-start" },
        alignItems: "center",
        mt: { xs: "26.89px", sm: "31px" },
    },
    button: {
        textAlign: "center",
        borderRadius: "0px",
        minWidth: { xs: "177.85px", sm: "200px", md: "302.45px" },
        height: { xs: "39.06px", sm: "44px", md: "70px" },
        fontSize: { xs: "12px", sm: "14px", md: "20px" },
        fontWeight: "500",
        lineHeight: { xs: "24px", sm: "21.6px", md: "25px" },
        p: "0px",
        backgroundColor: "#0F0F0F",
        color: "#FFFFFF",
    },
    titleBox: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        mb: "10px",
    },
    titleMain: {
        fontSize: { xs: "16px", sm: "20px", md: "24px" },
        fontWeight: "500",
        lineHeight: { xs: "24px", sm: "21.6px", md: "25px" },
        color: "#0F0F0F",
    },
    backButton: {
        color: "#0F0F0F",
        ml: "-8px"
    },
}

export default aboutUsSectionStyles;